import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ManufacturerReferences" })
export default class ManufacturerReferences extends Vue {
    public localizer: any = Localizer;
    public referencesOE: any[] = [];

    @Prop() readonly bremboCode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getProductOE();
    }

    public async getProductOE() {
        const result = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductManufacturerReferences, { bremboCode: this.bremboCode })).data;

        this.referencesOE = result;
    }

    public async searchCompetitor(referenceCode: string) {
        const result = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchCode, { code: referenceCode })).data;

        window.location.href = result.url;
    }
}